var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.activeTimeLog)?_c('timer-stop',{attrs:{"activeTimeLog":_vm.activeTimeLog}}):_c('timer-start',{attrs:{"startTimeLimit":_vm.lastTimeLogStoppedAt}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62d10186","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timer.vue
// module id = j4QQ
// module chunks = 1